'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    INITIAL_STATE_LISTADO_PRODUCTO,
    GET_ALL_PRODUCTS_LISTADO_PRODUCTO,
    GET_ALL_PRODUCTS_RESULT_LISTADO_PRODUCTO,
    ROLLBACK_LISTADO_PRODUCTO,
    FILTER_SEARCH_USER_LISTADO_PRODUCTO,
    SELECT_ALL_CHECKBOX_LISTADO_PRODUCTO,
    CLICK_CHECKBOX_LISTADO_PRODUCTO,
    CHANGE_STATES_LISTADO_PRODUCTO,
    CHANGE_STATES_SELECTION_LISTADO_PRODUCTO,
    CHANGE_STATES_SELECTION_DONE_LISTADO_PRODUCTO,
    FILTER_CHECKBOX_LISTADO_PRODUCTO,
    FILTER_ORDER_COLUMN_LISTADO_PRODUCTO,
    DISABLE_BUTTON_LISTADO_PRODUCTO,
    GENERAL_FILTER_LISTADO_PRODUCTO,
    UPDATE_MOTIVO_BLOQUEO_LISTADO_PRODUCTO,
    DELETE_PRODUCTOS_LISTADO_PRODUCTO,
    ROUTE_TO_NUEVO_PRODUCTO_LISTADO_PRODUCTO,
    ROUTE_TO_EDITAR_PRODUCTO_LISTADO_PRODUCTO,
    FUNCTION_CODE_CREATE_LISTADO_PRODUCTO,
    FUNCTION_CODE_DELETE_LISTADO_PRODUCTO,
    FUNCTION_CODE_EXPORT_LISTADO_PRODUCTO,
    FUNCTION_CODE_EDIT_LISTADO_PRODUCTO,
    SET_USER_FUNCTIONS_LISTADO_PRODUCTO,
    FUNCTION_CODE_QUERY_LISTADO_PRODUCTO,
    LISTADO_PRODUCTOS_REDIRECT_LISTADO_PRODUCTO
} from '../../Screens/ListadoProductos/actions/ListadoProductosActions';

/**
 * Estado inicial.
 */
const initialState = {
    data: {
        get_all_products: null,
        get_all_products_filter: null,
        checks: [],
        checksDeleted: [],
        deleteProducts: [],
        search: "",
        disableTrashButton: true,
        activo: true,
        bloqueado: true,
        selectAllCheckbox: false,
        countCheckboxToBlock: 0,
        columnIndex: 0,
        motivo: "",
        column: [{ "name": "nombre", "state": false }, { "name": "login", "state": true }, { "name": "sucursal", "state": true }, { "name": "sector", "state": true }],
        checksFilter: [{ "name": "todo", "state": true }, { "name": "activos", "state": true }, { "name": "bloqueados", "state": true }, { "name": "eliminados", "state": true }],
        user_functions: null,
        user_features: null,
        current_user: null
    },
    redirect: {
        shouldRedirect: false,
        to: null
    }
};

let result;
function listadoProductos(state = initialState, action) {
    LogHelper.In(listadoProductos.name, state, action);

    switch (action.type) {

        case INITIAL_STATE_LISTADO_PRODUCTO:
            const newInit = JSON.parse(JSON.stringify(initialState));
            result = newInit;
            break;

        case GET_ALL_PRODUCTS_LISTADO_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case GET_ALL_PRODUCTS_RESULT_LISTADO_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    get_all_products: action.data.get_all_products,
                    get_all_products_filter: action.data.get_all_products_filter,
                    checks: action.data.checks,
                    checksDeleted: action.data.checksDeleted,
                    deleteProducts: action.data.deleteProducts,
                    search: action.data.search,
                    disableTrashButton: action.data.disableTrashButton,
                    activo: action.data.activo,
                    bloqueado: action.data.bloqueado,
                    selectAllCheckbox: action.data.selectAllCheckbox,
                    countCheckboxToBlock: action.data.countCheckboxToBlock,
                    columnIndex: action.data.columnIndex,
                    motivo: action.data.motivo,
                    column: action.data.column,
                    checksFilter: action.data.checksFilter,
                    user_functions: action.data.user_functions,
                    current_user: action.data.current_user,
                }
            };
            break;

        case SELECT_ALL_CHECKBOX_LISTADO_PRODUCTO:

            selectAllCheckbox(state);
            state.data.disableTrashButton = !(state.data.checks.length > 0);
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case CLICK_CHECKBOX_LISTADO_PRODUCTO:

            let i = state.data.checks.indexOf(action.valueId);
            if (i == -1) {
                state.data.checks.push(action.valueId);
            } else {
                state.data.get_all_products.forEach(function (item) {
                    let i = state.data.checks.indexOf(action.valueId);
                    if (i >= 0) {
                        state.data.checks.splice(i, 1);
                    }
                });
            }
            state.data.selectAllCheckbox = (state.data.checks.length == state.data.get_all_products.length);
            state.data.disableTrashButton = !(state.data.checks.length > 0);
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case CHANGE_STATES_LISTADO_PRODUCTO:

            changeStates(state, action.valueId, action.valueActivo, action.valueBloqueado);
            generalFilter(state);
            result = {
                ...state
            };

            break;

        case CHANGE_STATES_SELECTION_LISTADO_PRODUCTO:

            changeStateWithCheckSelection(state, action.value);
            generalFilter(state);
            result = {
                ...state
            };
            break;

        case DISABLE_BUTTON_LISTADO_PRODUCTO:

            getTrashButtonDisabled(state, action.valueId);
            getBlockButtonDisabled(state, action.valueId);
            result = {
                ...state
            };
            break;

        case FILTER_CHECKBOX_LISTADO_PRODUCTO:

            state.data.checksFilter[action.valueIndex].state = !state.data.checksFilter[action.valueIndex].state;
            generalFilter(state);
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case FILTER_SEARCH_USER_LISTADO_PRODUCTO:

            state.search = action.value;
            generalFilter(state);
            result = {
                ...state
            };
            break;

        case FILTER_ORDER_COLUMN_LISTADO_PRODUCTO:

            state.data.columnIndex = action.value;
            state.data.column[action.value].state = !state.data.column[action.value].state;
            generalFilter(state);
            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case UPDATE_MOTIVO_BLOQUEO_LISTADO_PRODUCTO:

            state.motivo = action.motivoBloqueo;
            changeStateWithCheckSelection(state, 1);
            result = {
                ...state
            };
            break;

        case SET_USER_FUNCTIONS_LISTADO_PRODUCTO:

            result = {
                ...state,
                data: {
                    ...state.data,
                    userFeatures: action.userFeatures,
                    userFunctions: action.userFunctions
                }
            };
            break;

        case DELETE_PRODUCTOS_LISTADO_PRODUCTO:

            for (i = 0; i < state.data.checks.length; i++) {
                let idProduct = state.data.deleteProducts.find(x => x === state.data.checks[i]);
                if (idProduct === undefined) {
                    state.data.deleteProducts.push(state.data.checks[i]);
                    state.data.checksDeleted.push(state.data.checks[i]);
                }
            }
            selectAllCheckbox(state);
            state.data.disableTrashButton = !(state.data.checks.length > 0);
            state.data.checks = [];
            state.data.selectAllCheckbox = false;
            $('#confirm-delete-header').modal('toggle');

            result = {
                ...state,
                data: {
                    ...state.data
                }
            };
            break;

        case LISTADO_PRODUCTOS_REDIRECT_LISTADO_PRODUCTO:

            return {
                ...state,
                redirect: {                    
                    shouldRedirect: true,
                    to: action.data
                }
            }
            break;

        default:

            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(listadoProductos.name, result);
    return result;
};

/**
 * Habilita/Deshabilita el botón 'BLOQUEAR' al seleccionar los checks de la grilla que ya lo contienen
 * @param {any} valueId
 */
function getBlockButtonDisabled(state, valueId) {
    LogHelper.In(getBlockButtonDisabled.name, state, valueId);

    if (state.data.checks[0] != undefined) {
        let i = state.data.checks.indexOf(valueId);
        if (i == -1) {
            state.data.disableBlockButton = false;
        }
        else {
            let row = state.data.get_all_products.find(x => x.Id == valueId);
            if (row.Activo == false && row.Bloqueado == true) {
                state.data.disableBlockButton = true;
            }
            else {
                state.data.disableBlockButton = false;
            }
        }
    }
    else {
        state.data.disableBlockButton = true;
    }
}

/**
 * Habilita/Deshabilita el botón 'ELIMINAR' al seleccionar los checks de la grilla que ya lo contienen
 * @param {any} valueId
 */
function getTrashButtonDisabled(state, valueId) {
    LogHelper.In(getTrashButtonDisabled.name, state, valueId);

    if (state.data.checks[0] != undefined) {
        let i = state.data.checks.indexOf(valueId);
        if (i == -1) {
            state.data.disableTrashButton = false;
        }
        else {
            let row = state.data.get_all_products.find(x => x.Id == valueId);
            if (row.Activo == false && row.Bloqueado == false) {
                state.data.disableTrashButton = true;
            }
            else {
                state.data.disableTrashButton = false;
            }
        }
    }
    else {
        state.data.disableTrashButton = true;
    }
}

/**
 * Cambia el estado de los checks seleccionados
 * @param {any} typeButton 0 (Eliminar) typeButton: 1 (Bloquear)
 */
function changeStateWithCheckSelection(state, typeButton) {
    LogHelper.In(changeStateWithCheckSelection.name, state, typeButton);

    let _idsBlockeds = [];
    let _screenDataRollback = JSON.parse(JSON.stringify(state.data));

    let date = new Date();
    let datetime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace("T", " ").replace("Z", "");
    let currentId = state.data.current_user;

    state.data.checks.forEach(function (row) {
        let _userIndex = state.data.get_all_products.findIndex((el) => el.Id === row);
        let _userFilterIndex = state.data.get_all_products_filter.findIndex((el) => el.Id === row);
    });
}

/**
 * Cambia el estado del boton perteneciente a la fila de la grilla
 * @param {any} ID
 * @param {any} activo
 * @param {any} bloqueado
 */
function changeStates(state, ID, activo, bloqueado) {
    LogHelper.In(changeStates.name, state, ID, activo, bloqueado);

    let _screenDataRollback = JSON.parse(JSON.stringify(state.data));

    let horaYfecha = "";
    let currentId = state.data.current_user;

    if (activo == false && bloqueado == false) {
        let date = new Date();
        horaYfecha = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace("T", " ").replace("Z", "");
    }

    //updateUserState(ID, activo, bloqueado, horaYfecha, currentId);

    let row = state.data.get_all_products.find(x => x.Id == ID);

    row.Activo = activo;
    row.Bloqueado = bloqueado;
    row.HoraBloqueo = row.FechaBloqueo = row.HoraEliminado = row.FechaEliminado = horaYfecha;

    let index = state.data.get_all_products_filter.findIndex((el) => el.Id === row.Id);
    state.data.get_all_products_filter[index].Activo = activo;
    state.data.get_all_products_filter[index].Bloqueado = bloqueado;
    state.data.get_all_products_filter[index].HoraBloqueo = state.data.get_all_products_filter[index].FechaBloqueo =
        state.data.get_all_products_filter[index].HoraEliminado = state.data.get_all_products_filter[index].FechaEliminado = horaYfecha;
}

/**
 * Funcion general de filtrado que realiza (busqueda por nombre, por filtros y ordenamiento de columnas ascendente y descendente)
 */
function generalFilter(state) {
    LogHelper.In(generalFilter.name, state);

    state.data.get_all_products_filter = JSON.parse(JSON.stringify(state.data.get_all_products));
    state.data.get_all_products_filter.forEach(function (row) {
        row.Descripcion = row.Descripcion == null ? "" : row.Descripcion;
    });
    filterByChecks(state);
    filterByName(state);
    filterByOrderColumn(state);
}

/**
 * Filtra la grilla por los checks de activos, bloqueados y eliminados
 * @param {any} state estado del store.
 */
function filterByChecks(state) {
    LogHelper.In(filterByChecks.name, state);

    let filterRows = [];

    state.data.get_all_products_filter.forEach(function (row) {

        //Activo
        if (state.data.checksFilter[1].state == true && state.data.checksFilter[2].state == false && state.data.checksFilter[3].state == false) {
            if (row.Activo == true && row.Bloqueado == false) {
                filterRows.push(row);
                return;
            }
        }
        //Bloqueado
        if (state.data.checksFilter[1].state == false && state.data.checksFilter[2].state == true && state.data.checksFilter[3].state == false) {
            if (row.Activo == false && row.Bloqueado == true) {
                filterRows.push(row);
                return;
            }
        }
        //Eliminado
        if (state.data.checksFilter[1].state == false && state.data.checksFilter[2].state == false && state.data.checksFilter[3].state == true) {
            if (row.Activo == false && row.Bloqueado == false) {
                filterRows.push(row);
                return;
            }
        }
        //Activo y Bloqueado
        if (state.data.checksFilter[1].state == true && state.data.checksFilter[2].state == true && state.data.checksFilter[3].state == false) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == true)) {
                filterRows.push(row);
                return;
            }
        }
        //Activo y Eliminado
        if (state.data.checksFilter[1].state == true && state.data.checksFilter[2].state == false && state.data.checksFilter[3].state == true) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == false)) {
                filterRows.push(row);
                return;
            }
        }
        //Bloqueado y Eliminado
        if (state.data.checksFilter[1].state == false && state.data.checksFilter[2].state == true && state.data.checksFilter[3].state == true) {
            if ((row.Activo == false && row.Bloqueado == true) || (row.Activo == false && row.Bloqueado == false)) {
                filterRows.push(row);
                return;
            }
        }
        //Activo, Bloqueado y Eliminado
        if (state.data.checksFilter[1].state == true && state.data.checksFilter[2].state == true && state.data.checksFilter[3].state == true) {
            filterRows.push(row);
            return;
        }
    });

    state.data.get_all_products_filter = filterRows;
}

/**
 * Filtra la grilla por nombre
 * @param {any} state estado del store.
 */
function filterByName(state) {
    LogHelper.In(filterByName.name, state);

    if (state.data.search == "") {
        return;
    }

    let filterRows = [];

    state.data.get_all_products_filter.forEach(function (row) {
        row.Nombre = row.Nombre == null ? "" : row.Nombre;
        if (row.Nombre.toUpperCase().includes(state.data.search.toUpperCase())) {
            filterRows.push(row);
        }

    });

    state.data.get_all_products_filter = filterRows;

}

/**
 * Orderna la grilla de forma ascendente y descendente
 * @param {any} state estado del store.
 */
function filterByOrderColumn(state) {
    LogHelper.In(filterByOrderColumn.name, state);

    let filterRows = [];
    let obj = "";
    if (state.data.column[state.data.columnIndex].state == true) {
        state.data.get_all_products_filter = state.data.get_all_products_filter.sort(function (a, b) {
            return sortArray(state, a, b, -1, 1);
        });
    }
    else {
        state.data.get_all_products_filter = state.data.get_all_products_filter.sort(function (a, b) {
            return sortArray(state, a, b, 1, -1);
        });
    }
}

/**
 * Inserta en el array todos los checks seleccionados o quita los deseleccionados
 */
function selectAllCheckbox(state) {
    LogHelper.In(selectAllCheckbox.name, state);

    state.data.selectAllCheckbox = !state.data.selectAllCheckbox;
    if (state.data.selectAllCheckbox) {
        state.data.get_all_products.forEach(function (item) {
            let i = state.data.checks.indexOf(item.Id);
            if (i == -1) {
                state.data.checks.push(item.Id);
            }
        });
    }
    else {
        state.data.get_all_products.forEach(function (item) {
            let i = state.data.checks.indexOf(item.Id);
            if (i >= 0) {
                state.data.checks.splice(i, 1);
            }
        });
    }
}

/**
 * Ordena la información de manera ascendente o descendente según los parametros recibidos.
 * @param {any} state estado del store.
 * @param {any} a
 * @param {any} b
 * @param {any} asc
 * @param {any} desc
 */
function sortArray(state, a, b, asc, desc) {
    LogHelper.In(sortArray.name, state, a, b, asc, desc);

    let firstRow = "";
    let SecondRow = "";
    switch (state.data.columnIndex) {
        case 0:
            firstRow = a.Descripcion.toUpperCase()
            SecondRow = b.Descripcion.toUpperCase();
            break;
        case 1:
            firstRow = a.AdministradoraDescrip.toUpperCase();
            SecondRow = b.AdministradoraDescrip.toUpperCase();
            break;
        case 2:
            firstRow = a.TipoEmpresa.toUpperCase();
            SecondRow = b.TipoEmpresa.toUpperCase();
            break;
    }

    if (firstRow > SecondRow) {
        LogHelper.Out(sortArray.name, asc);
        return asc;
    }
    if (firstRow < SecondRow) {
        LogHelper.Out(sortArray.name, desc);
        return desc;
    }

    LogHelper.Out(sortArray.name, 0);
    return 0;
}

export default listadoProductos;